import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/** Query flag the Angular service worker checks before handling a request itself. */
export const NGSW_BYPASS_PARAM = 'ngsw-bypass';

/**
 * Sends file uploads straight to the network instead of through the service worker.
 *
 * ngsw-worker answers every fetch with `respondWith` and re-issues it with `fetch(req)`.
 * iOS Safari loses a file-backed FormData body on that re-issue, so the upload arrives
 * with an empty body, express-fileupload leaves `req.body` undefined, and the backend
 * fails with "Cannot read properties of undefined (reading 'service_type')". Chrome on
 * iOS has no service worker, which is why the same upload worked there.
 *
 * The query parameter is used rather than the `ngsw-bypass` header because a custom
 * header on a cross-origin upload would need the backend's CORS config to allow it.
 */
@Injectable()
export class ServiceWorkerBypassInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!(req.body instanceof FormData)) {
            return next.handle(req);
        }
        return next.handle(req.clone({ setParams: { [NGSW_BYPASS_PARAM]: 'true' } }));
    }
}
